export const api_config = {
	API_BASEURL: process.env.REACT_APP_API_BASEURL,
};
